import React from 'react';

/**
 * Inline error for a primary action — "couldn't … — reason — Retry".
 */
export default function PrimaryActionError({ message, onRetry, onDismiss, testId = 'primary-action-error' }) {
  if (!message) return null;

  return (
    <div
      role="alert"
      data-testid={testId}
      style={{
        marginBottom: 12,
        padding: '10px 14px',
        borderRadius: 10,
        background: 'rgba(239,68,68,0.08)',
        border: '1px solid rgba(239,68,68,0.25)',
        fontSize: 12,
        color: '#fecaca',
        lineHeight: 1.45,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 10,
      }}
    >
      <span style={{ flex: 1, minWidth: 180 }}>{message}</span>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          style={{
            padding: '5px 12px',
            borderRadius: 6,
            border: 'none',
            background: 'rgba(255,255,255,0.12)',
            color: '#fff',
            fontWeight: 700,
            fontSize: 11,
            cursor: 'pointer',
          }}
        >
          Retry
        </button>
      )}
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Dismiss"
          style={{
            background: 'none',
            border: 'none',
            color: 'inherit',
            opacity: 0.7,
            cursor: 'pointer',
            fontSize: 16,
            lineHeight: 1,
          }}
        >
          ×
        </button>
      )}
    </div>
  );
}
